import { AuditLiveMentionConfidence } from '@mi-front/core';
import { Chip } from '@mi-front/ui';

import { FormattedMessage } from 'react-intl';

import { mentionStatusMessages } from './mention-status.messages';

export const MentionConfidence = ({ value }: { value: AuditLiveMentionConfidence }) => {
  return (
    <Chip
      size="sm"
      type={value === 'ACCEPTED' ? 'success' : value === 'REJECTED' ? 'danger' : 'light'}
    >
      <FormattedMessage {...mentionStatusMessages[value]} />
    </Chip>
  );
};
